export const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.hevycoach.app';
export const appStoreUrl = 'https://apps.apple.com/app/id6502961756';
